import type { ImageTeaser } from "../../../../aysa_api/services/navigation/v1/teaser.types";

export enum DropType {
  DROP_TYPE_UNSPECIFIED = 0,
  DROP_TYPE_LABEL = 1,
  DROP_TYPE_SHOES = 2,
  DROP_TYPE_PREMIUM = 3,
  DROP_TYPE_LIVESHOW = 4,
}

export interface Drop {
  id: number;
  type: DropType;
  imageTeaser: ImageTeaser;
  // The tracking is optional, in case it is `null` no tracking should be performed.
  promotionTracking?: Drop_PromotionTracking;
}

export interface Drop_PromotionTracking {
  id: string;
  name: string;
}
